import { ErrorResponse } from 'react-router-dom';
import {
  IResponse,
  IOrganizationSettingsDataSource,
  IOrganizationSettingsInitialValues,
} from '../types';
import { IUseHttpServiceProps } from '../services/type';
import { RequestMethods } from '../services/enum';

export default class OrganizationSettingsService {
  private readonly baseUrl = 'auth/organization/';

  constructor(
    private executeService: <T>(
      args: IUseHttpServiceProps,
    ) => Promise<T | ErrorResponse | null>,
    private parameters: string,
  ) {}

  async fetchData(): Promise<
    IResponse<IOrganizationSettingsDataSource> | ErrorResponse | null
  > {
    return await this.executeService<
      IResponse<IOrganizationSettingsDataSource>
    >({
      method: RequestMethods.GET,
      url: `${this.baseUrl}${this.parameters}`,
    });
  }

  async fetchItemById(
    id: number,
  ): Promise<IOrganizationSettingsDataSource | ErrorResponse | null> {
    return await this.executeService<IOrganizationSettingsDataSource>({
      method: RequestMethods.GET,
      url: `${this.baseUrl}${id}/`,
    });
  }

  async deleteItemById(id: number): Promise<unknown | ErrorResponse | null> {
    return await this.executeService<unknown>({
      method: RequestMethods.DELETE,
      url: `${this.baseUrl}${id}/`,
    });
  }

  async exportData(): Promise<{ download_url: string } | ErrorResponse | null> {
    return await this.executeService<{ download_url: string }>({
      method: RequestMethods.GET,
      url: `${this.baseUrl}export-excel/${this.parameters}`,
      contentType: 'multipart/form-data',
    });
  }

  async submitForm(
    values: IOrganizationSettingsInitialValues,
    selectedItem?: IOrganizationSettingsDataSource,
  ): Promise<IOrganizationSettingsDataSource | ErrorResponse | null> {
    const method = selectedItem ? RequestMethods.PUT : RequestMethods.POST;
    const url = selectedItem
      ? `${this.baseUrl}${selectedItem.id}/`
      : this.baseUrl;

    return await this.executeService<IOrganizationSettingsDataSource>({
      method,
      url,
      data: values,
    });
  }
}
